import * as React from 'react';
import styled from 'styled-components';

import BoxPlusIcon from '../components/BoxPlusIcon';

const AddEventBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

type BoxPlusProps = {
  fullWidth?: boolean;
};

const BoxPlus = styled(BoxPlusIcon)<BoxPlusProps>`
  ${(props): string => (props.fullWidth ? 'flex-grow: 1;' : '')}
  ${(props): string => (props.fullWidth ? 'border-radius: 3px;' : '')};
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 4px;
`;

type Props = {
  isHovered: boolean;
} & BoxPlusProps;

const AddEventBox: React.FC<React.PropsWithChildren<Props>> = ({ isHovered, fullWidth }) => {
  if (!isHovered) {
    return null;
  }
  return (
    <AddEventBoxWrapper>
      <BoxPlus isHovered fullWidth={fullWidth} />
    </AddEventBoxWrapper>
  );
};

export default AddEventBox;
